export class KeepObject {
  canKeep = false;
  indexes: {[name: number]: KeepObject} = {};
  fields: {[name: string]: KeepObject} = {};
}
